var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_2282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9112 2.25121C12.7689 2.00333 12.5637 1.79739 12.3164 1.65418C12.069 1.51096 11.7883 1.43555 11.5024 1.43555C11.2166 1.43555 10.9359 1.51096 10.6885 1.65418C10.4412 1.79739 10.236 2.00333 10.0937 2.25121L0.236759 19.0225C-0.420179 20.1409 0.367571 21.5626 1.64551 21.5626H21.3579C22.6359 21.5626 23.4251 20.1395 22.7667 19.0225L12.9112 2.25121ZM11.4996 7.18758C12.2686 7.18758 12.8709 7.85171 12.7933 8.6179L12.2902 13.6592C12.2733 13.8573 12.1827 14.0417 12.0363 14.1762C11.8899 14.3106 11.6983 14.3852 11.4996 14.3852C11.3008 14.3852 11.1093 14.3106 10.9629 14.1762C10.8165 14.0417 10.7259 13.8573 10.7089 13.6592L10.2058 8.6179C10.1878 8.43711 10.2078 8.25454 10.2645 8.08195C10.3213 7.90936 10.4136 7.75058 10.5355 7.61583C10.6574 7.48109 10.8061 7.37336 10.9722 7.2996C11.1382 7.22585 11.3179 7.18769 11.4996 7.18758ZM11.5024 15.8126C11.8837 15.8126 12.2493 15.964 12.5189 16.2336C12.7885 16.5032 12.9399 16.8688 12.9399 17.2501C12.9399 17.6313 12.7885 17.997 12.5189 18.2665C12.2493 18.5361 11.8837 18.6876 11.5024 18.6876C11.1212 18.6876 10.7556 18.5361 10.486 18.2665C10.2164 17.997 10.0649 17.6313 10.0649 17.2501C10.0649 16.8688 10.2164 16.5032 10.486 16.2336C10.7556 15.964 11.1212 15.8126 11.5024 15.8126Z",
    fill: "#D7C311"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_2282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2db662f81541f6012c456ae5be3c0ec2.svg";
export { ForwardRef as ReactComponent };